var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-wrap"},_vm._l((_vm.numPages),function(item,index){return _c('pdf',{key:item,class:{ bb: index !== _vm.numPages - 1 },attrs:{"src":_vm.pdfSrc,"page":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }